exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-link[data-v-2fd381f0]{margin-right:16px;color:var(--lav-green-dark);font-weight:600;text-decoration:none}.view-link[data-v-2fd381f0]:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fd381f0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/DeletedPortfolios.vue
// module id = 627
// module chunks = 0